/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Locations API
 * AV Services Locations management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  BulkUpdateSpaceDto,
  CloneRoomDto,
  CreateSpaceDto,
  SpaceBreadcrumbsDto,
  SpacesControllerBulkReorderSpacesV1200,
  SpacesControllerBulkReorderSpacesV1PathParameters,
  SpacesControllerCloneRoomV1200,
  SpacesControllerCloneRoomV1PathParameters,
  SpacesControllerCreateV1201,
  SpacesControllerCreateV1PathParameters,
  SpacesControllerDeleteV1PathParameters,
  SpacesControllerFindAllV1200,
  SpacesControllerFindAllV1Params,
  SpacesControllerFindAllV1PathParameters,
  SpacesControllerFindOneV1200,
  SpacesControllerFindOneV1PathParameters,
  SpacesControllerGetSpaceBreadcrumbsV1PathParameters,
  SpacesControllerUpdateV1200,
  SpacesControllerUpdateV1PathParameters,
  UpdateSpaceDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class SpacesService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Retrieve all spaces for a given location
   */

  findAll<TData = SpacesControllerFindAllV1200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, locationId }: SpacesControllerFindAllV1PathParameters,
    params?: SpacesControllerFindAllV1Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/locations/v1/clients/${clientId}/locations/${locationId}/spaces`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * @summary Create a new space
   */

  create<TData = SpacesControllerCreateV1201>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, locationId }: SpacesControllerCreateV1PathParameters,
    createSpaceDto: CreateSpaceDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/locations/v1/clients/${clientId}/locations/${locationId}/spaces`, createSpaceDto);
  }
  /**
   * @summary Get breadcrumbs path for a floor or room
   */

  getSpaceBreadcrumbs<TData = SpaceBreadcrumbsDto>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    locationId,
    spaceId,
  }: SpacesControllerGetSpaceBreadcrumbsV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/locations/v1/clients/${clientId}/locations/${locationId}/spaces/${spaceId}/breadcrumbs`);
  }
  /**
   * @summary Retrieve a specific space
   */

  findOne<TData = SpacesControllerFindOneV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    locationId,
    spaceId,
  }: SpacesControllerFindOneV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/locations/v1/clients/${clientId}/locations/${locationId}/spaces/${spaceId}`);
  }
  /**
   * @summary Update an existing space
   */

  update<TData = SpacesControllerUpdateV1200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, locationId, spaceId }: SpacesControllerUpdateV1PathParameters,
    updateSpaceDto: UpdateSpaceDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/locations/v1/clients/${clientId}/locations/${locationId}/spaces/${spaceId}`, updateSpaceDto);
  }
  /**
   * @summary Delete a space
   */

  delete<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    locationId,
    spaceId,
  }: SpacesControllerDeleteV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/locations/v1/clients/${clientId}/locations/${locationId}/spaces/${spaceId}`);
  }
  /**
   * @summary Bulk reorder spaces
   */

  bulkReorderSpaces<TData = SpacesControllerBulkReorderSpacesV1200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, locationId }: SpacesControllerBulkReorderSpacesV1PathParameters,
    bulkUpdateSpaceDto: BulkUpdateSpaceDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/locations/v1/clients/${clientId}/locations/${locationId}/spaces/reorder`, bulkUpdateSpaceDto);
  }
  /**
   * @summary Clone a space (room) multiple times
   */

  cloneRoom<TData = SpacesControllerCloneRoomV1200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, locationId, spaceId }: SpacesControllerCloneRoomV1PathParameters,
    cloneRoomDto: CloneRoomDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/locations/v1/clients/${clientId}/locations/${locationId}/spaces/${spaceId}/clone-room`, cloneRoomDto);
  }
}
